export default __webpack_public_path__ + "images/677e4d5aa1a57c6fa923c14d68665f75-world_music.jpg";